/* eslint-disable react/no-unknown-property */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Icon from '../Icon'
import TabeRowHeaderContent from './TableRowHeaderContent'

const styles = theme => ({
  markCell: {
    color: `var(--gameday-table-tableHeaderTextColor, ${theme.table.tableHeaderTextColor})`,
    backgroundColor: `var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`,
    width: 31,
    paddingLeft: 9,
    position: 'relative',
  },
  dragMark: {
    width: 30,
  },
  noPadding: {
    padding: 0,
  },
  danger: {
    backgroundColor: theme.status.errorBG,
  },
  isLocked: {
    pointerEvents: 'none',
    '& td, & th': {
      backgroundColor: theme.table.tableHeaderLockedBgColor,
      borderColor: `${theme.table.tableHeaderLockedBgColor} !important`,
    },
    '& svg.Icon-svgIcon-1215': {
      opacity: '.7',
    },
  },
  dragging: {
    display: 'table',
    border: theme.borders.default,
    borderCollapse: 'separate',
    borderRadius: '4px',
    backgroundColor: `var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`,
    boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.2)',
    '& td, & th': {
      borderTop: 'none !important',
      borderBottom: 'none !important',
      background: 'none !important',
      '&:before, &:after': {
        display: 'none',
      },
    },
  },
})

const TableRowHeader = ({
  cols,
  count,
  heading,
  tableGroupActions,
  tableGroupCount,
  tableGroupDescription,
  tableGroupHeaderSize,
  tableGroupRules,
  provided,
  isDraggable,
  isDragging,
  classes,
  row,
}) => {
  return (
    <tr
      className={cn(row.isLocked && classes.isLocked, isDragging && classes.dragging, classes.rowHeader, 'groupHeader')}
      tableGroupHeaderSize={tableGroupHeaderSize}
      {...(provided
        ? {
            ref: provided.innerRef,
            ...provided.dragHandleProps,
            ...provided.draggableProps,
          }
        : {})}
    >
      {isDraggable && (
        <td className={cn(classes.markCell, row.action === 'delete' && classes.danger, isDragging && classes.dragMark)}>
          {!row.isLocked && <Icon iconName="fieldDragHandle" iconSize="10" />}
        </td>
      )}
      <TabeRowHeaderContent
        tableGroupHeaderSize={tableGroupHeaderSize}
        tableGroupCount={tableGroupCount || row.includeProductGroupCount}
        heading={heading}
        count={count}
        tableGroupDescription={tableGroupDescription}
        tableGroupActions={tableGroupActions}
        tableGroupRules={tableGroupRules}
        row={row}
        isDragging={isDragging}
        className={cn({ isLocked: row.isLocked })}
        cols={cols}
      />
    </tr>
  )
}

TableRowHeader.defaultProps = {
  cols: 0,
}

const RowHeaderComponent = withStyles(styles)(TableRowHeader)
RowHeaderComponent.displayName = 'RowHeaderComponent'
export default RowHeaderComponent
